<script setup lang="ts">
import { useMmmIsDemoProject } from '#mmm/composables/useMmmIsDemoProject'
import { Badge } from '@forgd/ui-kit/badge'

const isDemoProject = useMmmIsDemoProject()
</script>

<template>
  <div data-testid="mm-dashboard">
    <NuxtLoadingIndicator />
    <NuxtLayout
      name="dashboard"
      :page-header="{ description: 'Free Tools', title: 'Monitor Market Makers', icon: '/icons/market-maker-monitoring-next.svg' }"
    >
      <template #header>
        <div class="flex items-center gap-2">
          <img src="/icons/market-maker-monitoring.svg" alt="Token Designer Icon" width="32" height="32">
          <div class="shrink-0 text-sm font-semibold">
            Monitor Market Makers
          </div>
          <Badge v-if="isDemoProject" variant="gray">
            Demo
          </Badge>
        </div>
      </template>
      <template #page-header-suffix>
        <Badge v-if="isDemoProject" variant="gray">
          Demo
        </Badge>
      </template>
      <template v-if="$slots.sidebar" #sidebar>
        <slot name="sidebar" />
      </template>
      <template #footer>
        <slot name="footer" />
      </template>
      <template #app-footer>
        <CoreAppFooterBlock />
      </template>
      <slot />
    </NuxtLayout>
  </div>
</template>
